import React, { useState, useRef } from "react";
import "./App.css";

export default function Envelope() {
  const [isOpened, setIsOpened] = useState(false);
  const [showLetter, setShowLetter] = useState(false);
  const audioRef = useRef(null); // ✅ 오디오 참조

  const handleEnvelopeClick = () => {
    if (!isOpened) setIsOpened(true);
  };

  const handleLetterClick = () => {
    if (isOpened && !showLetter) {
      setShowLetter(true);
      if (audioRef.current) {
        audioRef.current.play().catch((err) => {
          console.log("재생 실패: ", err);
        });
      }
    }
  };

  return (
    <div className="envelope-container">
      {/* ✅ 숨겨진 배경음악 */}
      <audio ref={audioRef} src="/bgm.mp3" loop />

      {!isOpened && (
        <div className="envelope closed" onClick={handleEnvelopeClick}>
          ✉️
          <br />
          <span>봉투를 눌러주세요</span>
        </div>
      )}

      {isOpened && !showLetter && (
        <div className="envelope opened" onClick={handleLetterClick}>
          📬
          <br />
          <span>편지를 열어보세요</span>
        </div>
      )}

      {showLetter && (
        <div className="letter-content">
          <h2>To. 사랑하는 하영이</h2>
          <div className="letter-text">
            <p>
              1주년 축하해!! 당연히 준비해야 했을 편지를 준비하지 못해서 급하게
              만들어봤어 ㅎㅎ.. 오늘 너무나 미안하고, 고마운 하루였어. 오늘 나의
              반응이 조금 부족하게 느껴졌을까? 하영이가 나를 그려준 그림, 그리고
              친구들을 관찰해서 하영이가 새롭게 만들어낸 그림, 스트레스 해소용
              키캡, 예쁘게 적어 내린 편지, 편지지, 사진, 코닥 카메라, 필름 속에
              담겨있는 사진들.. 늘 하영이는 내가 준 것 이상으로 돌려주기에 너무
              고마웠어. 오빠가 반응을 더 크게 해야 했는데 미안해 ㅎㅎ
              <br></br>
              <br></br>
              교환학생을 온 이후로 하영이에게 조금 소홀해진 부분이 있었던 것
              같아. 내 나름대로 열심히 노력은 해보았지만, 솔직히 말해서 쉽지가
              않았어. 우리 서로를 알기에 6개월이라는 시간은 짧은 시간이었고,
              그렇게 서로에 대한 부족한 이해로 초장거리 연애를 시작하다 보니
              삐걱거리는 일이 많았던 것 같아. 대부분의 갈등은 오빠가 문제였지.
              그것을 생각할 때마다 참 미안해.. 하영이가 미래를 위해 열심히
              공부하고 있을 때, 내가 내 인생을 즐긴다는 핑계로 하영이를 속 썩일
              법한 계기를 자꾸 만든 것 같아서.. 충분히 기분 나쁠 만한 일이
              있었는데도, 하영이는 항상 나와 우리의 관계를 생각해 줬어. 그래서
              너무 고마워.
              <br></br>
              <br></br>
              교환학생을 하면서 가장 크게 느끼고 있는 부분은, 내가 좇았던 행복은
              사실 내가 인지하지 못했을 뿐이라는 것이야. 내가 여러 여행을 하면서
              가장 행복했던 여행은 이번 슬로베니아 여행이었어. 특별한 액티비티와
              나라가 좋아서라기보단, 그냥 편안한 사람들과 술을 마시고, 이야기를
              하고, 자동차를 타고 다니면서 노래를 듣고.. 편한 사람들과 시간을
              보내는 것 자체가 행복했어. 여기 살면서도 특별한 활동을 하는 것이
              아니라, 날씨가 좋으면 밖에 나가서 피크닉을 하고, 자전거를 타고,
              가끔 바에도 가고.. 사실 한국에서 모두 할 수 있었는데도 나는 그것을
              잘 모르고 내 인생이 지루하고 뻔하다고 생각했어.
              <br></br>
              <br></br>
              하영이를 만나고 난 뒤로부터는 행복이 뭔지 조금은 알게 되었어. 그냥
              사랑하는 사람과 같이 시간을 보내는 것. 어디를 가냐보다 누구랑
              함께하느냐가 중요하다는 진부한 말을 너가 내 가슴에 와닿게
              만들었어. 매번 독특한 데이트 코스를 찾아보려고 했고, 하영이에게도
              그런 말을 넌지시 했었는데, 그럴 필요가 전혀 없었다는 것을 여기
              와서야 깨달았어. 주변 공원에 가서 피크닉을 할 수 있고, 한강에 가
              자전거를 탈 수 있고, 매번 가는 바에 가서 맥주를 마실 수 있고,
              공원에서 산책할 수 있고, 영화관에 갈 수 있고.. 뻔한 데이트
              코스지만 그건 별로 중요한 게 아니라는 걸 알았어.
              <br></br>
              <br></br>
              하지만 그때 당시에 나는 이미 교환학생을 결심한 상태였고,
              돌아가기엔 너무 늦었었어. 모호하게 느껴졌던 그 감정을 확인하고자
              나는 여기에 왔고, 비로소 나는 행복했다는 것을 알 수 있었어.
              하영이와 함께하면서 느꼈던 그 감정들이 행복이었구나라는 생각이
              매번 들었어.
              <br></br>
              <br></br>
              요즘엔 하영이와 페탐하는 시간이 너무 재미있어 ㅎㅎ 하영이와 나의
              개그 코드가 비슷한 탓일까? 내가 어떤 말을 해도 하영이는 진심으로
              웃는 게 느껴지고, 하영이가 무슨 말을 해도 나 또한 연기가 아니라
              진심으로 행복하고 웃겨서 웃음이 나오고 ㅎㅎ 가끔은 내가 너무
              장난을 심하게 쳐서 하영이가 속상할 때도 있지만 ㅋㅋㅋㅋ 전반적으로
              너무너무 재밌는 시간인 것 같아 페탐하는 시간은
              <br></br>
              <br></br>
              요즘 깊게 하고 있는 생각은 "어른이 되어간다는 것은, 주변에서 나의
              행동을 지적하는 사람이 없어진다는 것이 아닐까?"라는 거야. 세상을
              살다 보면 "나이도 먹을 만큼 먹었는데 왜 저렇게 사는 사람들이
              많지?" 라는 생각을 가끔 하곤 해. 그냥 그 사람들의 무지를 속으로
              비판하곤 했었는데, 최근에서는 "내가 저런 사람이 될 수도 있지
              않을까?"라는 생각을 해. 나는 20살 때부터 자취를 시작했고, 그렇기에
              내 주변 사람들은 항상 내 또래야. 내가 어떤 인생을 살든, 그들은
              내가 어떻게 되어가든 큰 상관이 없고, 나 또한 다른 사람들이 어떻게
              되어가든 큰 상관이 없어. 그렇기에 괜한 지적을 하면서 트러블을
              만들기보단, 이상한 행동을 보이면 자연스레 멀어지는 편인 거 같아.
              다른 사람들도 나에게 그러겠지. 하영이 또한 어쩌면 마찬가지 일 수도
              있고. 그렇게 내 행동을 지적하는 사람이 줄면, 나는 내 행동이 항상
              맞다고 생각을 하고 살 수도 있겠지. 그런 것이 몇십 년 동안 지속이
              되면, 그때는 정말 그게 내가 되고, 돌이킬 수 없어지는 것 같아. 항상
              자기 자신을 객관적으로 보려고 노력하고 있어. 혹시나 학창 시절의
              선생님이 지금의 나를 본다면 어떤 방식으로 혼을 냈을까를 생각하기도
              하면서.
              <br></br>
              <br></br>
              하영아 나는 아직 미성숙해. 하영이를 너무 사랑하지만, 당연하게도
              나는 완벽하지 않기에 이런저런 오해를 부를 수도 있고, 그 부분에서
              하영이가 상처를 받을 수도 있어. 완벽하지 않다는 핑계로 관계를
              대충하겠다는 이야기는 아니야. 앞으로 더 책임감을 느끼고, 관계에
              임하겠다고 다짐하고 싶었어. 내 미래를 생각할 때는 하영이가 항상
              있어. 미래에 집을 구한다면, "하영이와 내 직장의 중간 지점은 어디
              즘일까?"를 생각하기도 하고, 하영이와 나를 닮은 아이가 태어난다면
              어떤 성격일까?" "어떻게 생겼을까?"를 생각하기도 해.
              <br></br>
              <br></br>
              나는 부족한 부분이 많은 사람이야. 그래도 내가 느끼는 행복만큼
              하영이도 나와 있을 때 같이 행복했으면 좋겠어. 우리 평생 같이
              행복하면서 살자! 그게 내 인생의 목표야. 하영아 사랑해! 1주년
              축하하고 고마워!
            </p>
            <div className="letter-text1">From. 홍석</div>
          </div>
        </div>
      )}
    </div>
  );
}
